import React, { useMemo } from 'react';
import { toCssDeclarationName } from '@/features/editor/widgets/ai-component/inputs/shared/css-declarations';
import { NumberUnitInput } from '@/features/editor/widgets/ai-component/inputs/shared/number-unit-input';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';

export interface CssNumericUnitInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
}

export function CssNumericUnitInput({
  name,
  initialValue,
  onChange,
}: CssNumericUnitInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);
  const [error, setError] = React.useState<string>(``);

  const onValueChanged = (value: string) => {
    if (onChange) {
      onChange(name, value);
    }
  };

  return (
    <InlineInputCardWrapper className={error ? `error` : ``}>
      <span>{displayName}</span>
      <NumberUnitInput
        initialValue={initialValue}
        onChange={onValueChanged}
        onError={setError}
      />
    </InlineInputCardWrapper>
  );
}
